import { Link } from 'react-router-dom';
import { categories, movies } from '@/mocks/movies';

const categoryImages: Record<string, string> = {
  movie: 'https://readdy.ai/api/search-image?query=Collection%20of%20diverse%20movie%20posters%20arranged%20artistically%20on%20a%20warm%20cinema%20wall%2C%20film%20reels%20and%20clapperboard%20decorations%2C%20warm%20amber%20cinema%20lighting%2C%20vintage%20theater%20aesthetic%2C%20rich%20textures%20and%20golden%20accents&width=800&height=500&seq=cat-banner-movie&orientation=landscape',
  tv: 'https://readdy.ai/api/search-image?query=Modern%20living%20room%20with%20large%20flat%20screen%20TV%20displaying%20dramatic%20scene%2C%20cozy%20warm%20lighting%2C%20comfortable%20sofa%2C%20home%20theater%20atmosphere%2C%20evening%20ambience%2C%20golden%20warm%20tones&width=800&height=500&seq=cat-banner-tv&orientation=landscape',
  anime: 'https://readdy.ai/api/search-image?query=Colorful%20anime%20art%20studio%20with%20character%20designs%20and%20sketches%20on%20walls%2C%20warm%20creative%20atmosphere%2C%20manga%20and%20animation%20cels%20displayed%2C%20soft%20golden%20lighting%2C%20artistic%20Japanese%20anime%20aesthetic&width=800&height=500&seq=cat-banner-anime&orientation=landscape',
  variety: 'https://readdy.ai/api/search-image?query=Entertainment%20TV%20show%20stage%20with%20colorful%20lighting%20and%20studio%20equipment%2C%20warm%20spotlights%2C%20talk%20show%20set%20design%2C%20lively%20and%20energetic%20atmosphere%2C%20variety%20show%20production%20aesthetic&width=800&height=500&seq=cat-banner-variety&orientation=landscape',
};

export default function CategoryShowcase() {
  return (
    <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="text-center mb-8">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
          分类浏览
        </h2>
        <p className="text-sm text-foreground-500 mt-1">按类型探索你感兴趣的内容</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
        {categories.map((cat) => {
          const count = movies.filter((m) => m.category === cat.slug).length;
          return (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative rounded-lg overflow-hidden h-48 cursor-pointer"
            >
              <img
                src={categoryImages[cat.slug]}
                alt={cat.name}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <div className="flex items-center gap-2">
                  <i className={`${cat.icon} text-white text-lg w-5 h-5 flex items-center justify-center`}></i>
                  <h3 className="font-heading text-lg font-bold text-white">{cat.name}</h3>
                </div>
                <p className="text-white/70 text-xs mt-1">{count}+ 部精彩内容</p>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}